import { restClient } from '@/Core'

import { LETTER_TEMPLATE_VARIABLES_URL, type LetterTemplateVariable } from '../Contracts/LetterTemplate'

/**
 * Змінні провайдера для форми шаблону листа:
 * `GET /services/letter_templates/variables?provider=<код>` (`SPEC-013` §5.7).
 * Каталог залежить лише від провайдера, тож працює й для нового шаблону.
 */
export const LoadLetterTemplateVariablesTask = async (provider: string): Promise<LetterTemplateVariable[]> => {
    const raw = await restClient.get(`${LETTER_TEMPLATE_VARIABLES_URL}?provider=${encodeURIComponent(provider)}`)
    const data = raw as unknown as LetterTemplateVariable[] | null

    return Array.isArray(data)
        ? data.filter((item) => typeof item?.key === 'string' && typeof item?.label === 'string')
        : []
}
